export const getFullUrl = (url, baseUrl) => {
    if (!baseUrl || !url) {
        return url;
    }
    url = url.trim();
    if (url.indexOf('/') === 0 &&
        url.indexOf('//:') === -1 &&
        url.indexOf('static/media') === -1) {
        return baseUrl + url;
    }
    return url;
};
//# sourceMappingURL=getFullUrl.js.map